import type { PhoneNumber } from '@/scopes/checkout/domain/types'
import { countryData as defaultCountryData } from '@sunwebgroup/uds-ui/fields/phone-field'

export function mapPhoneNumber(phoneNumber: string, countryData = defaultCountryData): PhoneNumber | null {
  const sanitizedNumber = phoneNumber.startsWith('+') ? phoneNumber.slice(1) : phoneNumber

  for (const country of countryData) {
    if (sanitizedNumber.startsWith(country.code)) {
      const localNumber = sanitizedNumber.slice(country.code.length)

      const regex = new RegExp(country.pattern)
      if (regex.test(localNumber)) {
        return { countryCode: country.code, phoneNumber: localNumber }
      }
    }
  }

  return null
}

export function mapPhoneNumberToString(value: { countryCode: string, phoneNumber: string }): string {
  return `+${value.countryCode}${value.phoneNumber}`
}
